export const FETCH_LINKED_SPACES = 'state.actions.fetch-linked-spaces.FETCH_LINKED_SPACES' as const;

export type FetchLinkedSpacesPayload = {
	projectKey: string;
};

export type FetchLinkedSpaceAction = {
	type: typeof FETCH_LINKED_SPACES;
	payload: FetchLinkedSpacesPayload;
};

export const fetchLinkedSpaces = (payload: FetchLinkedSpacesPayload): FetchLinkedSpaceAction => ({
	type: FETCH_LINKED_SPACES,
	payload,
});
